import axios from 'axios';

const axios8200 = axios.create({
  baseURL: 'https://analyseapi-22559651326.us-east1.run.app',
  headers: {
    'Content-Type': 'application/json',
  },
});
// const axios8200 = axios.create({
//   baseURL: 'http://localhost:8200', // Set the base URL here
// });

export default axios8200;
